
//Import providers
import { PROVIDER } from "../core";
import ProxiCbGames from "./cbgames/Proxi.CbGames";
import ProxiMarlipin from "./marlipin/Proxi.Marlipin";
import ProxiProvider from "./Proxi.Provider";

export enum PROVIDERS {
  MARLIPIN = "MARLIPIN",
  CBGAMES = "CBGAMES",
}

export default class Proxi {
  private Provider: PROVIDERS = PROVIDER as any;
  private current: ProxiProvider;
  
  constructor() {
    this.current = this.setProvider();
  }  
  
  setProvider(): ProxiProvider {
    switch(this.Provider) {
      case PROVIDERS.MARLIPIN: return new ProxiMarlipin(); 
      case PROVIDERS.CBGAMES: return new ProxiCbGames();
      default: return new ProxiProvider();
    }
  }

  get provider(): ProxiProvider {
    return this.current;
  }
}